module.exports = __webpack_public_path__ + "assets/img/down_wechat.732a62ad.jpg";